import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';
import { StatesModule } from '@uirouter/angular';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { HistoryListComponent } from '@fi-app/history/history-list/history-list.component';

const HistoryState = {
    name: FiStateNames.History._name,
    url: '/History',
    abstract: true,
    parent: FiStateNames.GlobalSettings,
    component: FiAbstractStateComponent,
};

export function HistoryListPageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitleByTextId('history.activity_log');
}
const HistoryListState = {
    name: FiStateNames.History.List,
    url: '/?:sortColumn&:sortDirection&:offset',
    component: HistoryListComponent,
    reloadOnSearch: false,
    resolve: {
        pageTitle: [PageTitleService, HistoryListPageTitle],
    },
};

export const HistoryStates: StatesModule = {
    states: [HistoryState, HistoryListState],
};

export function registerHistoryStateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules([FiStateNames.History.List], {
        SettingType: [ApplicationSettingsType.CoreGlobal],
        AccessType: AccessRightType.Admin,
    });
}
